import { FIELD_TYPE } from "../../type/fileType";
import { STATUS } from "../../type/status";
import { formatDateToString } from "../../helper/common";

const { INPUT, DATE, SELECT } = FIELD_TYPE;

const dataFormUpload = [
  {
    type: SELECT,
    label: "Trưởng nhóm",
    name: "leadTeam",
    rules: [{ required: true, message: "Chưa chọn trưởng nhóm" }],
    css: { xs: 8, sm: 24, md: 24, lg: 24, xl: 24 },
  },
];

const listColumnsTableCreated = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    align: "center",
  },

  {
    title: "Tên hợp đồng",
    dataIndex: "originalFileName",
    key: "originalFileName",
  },

  {
    title: "Tạo bởi",
    dataIndex: "createdBy",
    key: "createdBy",
  },
  {
    title: "Trưởng nhóm",
    dataIndex: "leadUserFullName",
    key: "leadUserFullName",
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdDate",
    key: "createdDate",
    align: "center",
    render: (text, record) => {
      return formatDateToString(record.createdDate, "HH:mm:ss-DD/MM/YYYY");
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "mailSent",
    key: "mailSent",
    align: "center",
    render: (text, record) => {
      switch (record.mailSent) {
        case true:
          return <span style={{ color: "green" }}>Đã gửi</span>;
        // case "DRAFT":
        //   return <span style={{ color: "gray" }}>Bản nháp</span>;
        case false:
          return <span style={{ color: "red" }}>Chưa gửi</span>;
        default:
          return <span>{record.status}</span>;
      }
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    align: "center",
  },
];

const dataFindContract = [
  {
    type: INPUT,
    label: "Từ khóa tên hợp đồng",
    name: "originalFileName",
  },
  {
    type: INPUT,
    label: "Trưởng nhóm",
    name: "leadTeam",
  },
  {
    type: INPUT,
    label: "Tạo bởi",
    name: "createdBy",
  },
  {
    type: SELECT,
    label: "Trạng thái gửi mail",
    name: "status",
    options: [
      { label: "Chưa gửi ", value: false },
      { label: "Đã gửi", value: true },
    ],
  },
  {
    type: DATE,
    label: "Tạo ngày",
    name: "fromDate",
  },
];

const dataSendEmail = [
  {
    type: INPUT,
    label: "Email khách hàng",
    name: "toEmails",
    rules: [{ required: true, message: "Chưa nhập email khách hàng" }],
  },
  {
    type: INPUT,
    label: "cc Email",
    name: "ccEmails",
  },
  {
    type: INPUT,
    label: "bcc Email",
    name: "bccEmails",
  },
];

export {
  listColumnsTableCreated,
  dataFormUpload,
  dataFindContract,
  dataSendEmail,
};
